import type { FormkitReference } from "./references";

export type StandardBoolean = UnaryBoolean | BinaryBoolean | boolean;
export type FormkitBoolean = StandardBoolean | FunctionBoolean;

export const isFormkitBoolean = (value: any): value is FormkitBoolean => {
  return [BooleanType.Binary, BooleanType.Unary, BooleanType.Function].includes(
    value?.type,
  );
};

type BaseBoolean = {
  type: BooleanType;
};

export enum BooleanType {
  Unary = "unary",
  Binary = "binary",
  Function = "function",
}

export type UnaryBoolean = BaseBoolean & {
  type: BooleanType.Unary;
  operand: BooleanOperand | UnaryBoolean | BinaryBoolean;
  operator?: UnaryBooleanOperator;
};

export type BinaryBoolean = BaseBoolean & {
  type: BooleanType.Binary;
  leftOperand: BooleanOperand;
  operator: BinaryBooleanOperator;
  rightOperand: BooleanOperand;
};

export type FunctionBoolean = BaseBoolean & {
  type: BooleanType.Function;
  variables: Record<string, unknown> | null;
  function: string;
};

export type BooleanOperand = FormkitReference | string | number | boolean;

export enum UnaryBooleanOperator {
  Not = "not",
}

export enum BinaryBooleanOperator {
  Equals = "equals",
  NotEquals = "notEquals",
  GreaterThan = "greaterThan",
  LessThan = "lessThan",
  GreaterThanOrEqual = "greaterThanOrEqual",
  LessThanOrEqual = "lessThanOrEqual",
  And = "and",
  Or = "or",
}
